<template>
	<div class="containers">
		<div class="warning">
			<div class="d-flex">
				<img src="../../assets/images/iconPack/carbon_warning-square.svg" />
				<span class="text">توجه</span>
			</div>
			<div>
				<ul>
					<li class="persian-number">
						شما {{ ticketList.length }} تیکت باز دارید. در صورتی که مشکل حل شده است لطفا تیکت را
						ببندید.
					</li>
				</ul>
			</div>
		</div>
		<button @click="newTicket" class="new-ticket">
			<img class="icon" src="../../assets/images/iconPack/plus-white.svg" />
			تیکت جدید
		</button>
		<div class="table-box">
			<pagination v-model="page" :per-page="20" :records="totalDataCount" @paginate="myCallback" />
			<Tableview
				class="table pb-4"
				:hover="true"
				:bordered="true"
				:showNoContent="showContnetFunc"
				:showNoData="showDataFunc"
			>
				<template #TableTitle>
					<tr>
						<th>شماره</th>
						<th>عنوان</th>
						<th>موضوع</th>
						<th>وضعیت</th>
						<th>تاریخ آخرین به‌روزرسانی</th>
						<th>عملیات</th>
					</tr>
				</template>

				<template #TableBody>
					<tr
						@click="ticketDetailPage(item.id)"
						v-for="(item, index) in ticketList"
						:key="item.id"
						class="ticket-detail"
					>
						<td class="persian-number">{{ 1 + index }}</td>
						<td>{{ item.title }}</td>
						<td>{{ item.subject }}</td>
						<td v-if="item.status === 'A'">پاسخ داده شده</td>
						<td v-if="item.status === 'W'">در انتظار پاسخ</td>
						<td v-if="item.status === 'C'">بسته شده</td>
						<td>
							<!-- <input type="text" class="custom-input inputs" /> -->
							<!-- <date-picker
								v-model="item.datetime_last_change"
								range
								clearable
								format="YYYY-MM-DDTHH:mm:00"
								display-format="jMMMM jD"
								custom-input=".custom-input"
								:disabled="true"
							/> -->
							<date-picker
								v-model="item.datetime_last_change"
								type="datetime"
								format="YYYY-MM-DD"
								display-format="jYYYY-jMM-jDD"
								:timezone="true"
								:disabled="true"
							/>
						</td>
						<td v-if="item.status === 'W'"></td>
						<td v-if="item.status === 'C'">
							<input
								style="width: 20px; height: 20px"
								type="checkbox"
								checked="checked"
								:disabled="true"
							/>
						</td>
						<td @click="closeTicket(item.id)" v-if="item.status === 'A'">
							<button class="close-ticket">
								<img class="icon ml-2" src="../../assets/images/iconPack/charm_tick.svg" />
								بستن
							</button>
						</td>
					</tr>
				</template>
			</Tableview>
		</div>
	</div>
</template>
<script>
import Tableview from '../../components/Tableview/index.vue';
import Pagination from 'vue-pagination-2';

export default {
	components: {
		Tableview,
		Pagination,
	},
	data() {
		return {
			ticketList: 0,
			page: 1,
			totalDataCount: 0,
		};
	},
	computed: {
		showContnetFunc() {
			return this.ticketList === 0;
		},
		showDataFunc() {
			if (this.ticketList.length !== undefined) {
				return this.ticketList.length === 0;
			}
			return false;
		},
	},
	mounted() {
		this.getTicketList();
	},
	methods: {
		async getTicketList(limit = 20, offset = 0) {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.TICKET_LIST +
					'?limit=' +
					limit +
					'&offset=' +
					offset +
					'&ordering=-datetime_last_change' +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				'list', res.data;
				this.ticketList = res.data.results;
				this.totalDataCount = res.data.count;
			}
		},
		async myCallback() {
			await this.getTicketList(20, 20 * (this.page - 1));
		},
		async closeTicket(id) {
			const res = await this.$ApiServiceLayer.patch(
				this.$PATH.RELATIVE_PATH.MULTI.TICKET_EDIT + id + '/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				{ status: 'C' },
			);
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'تیکت با موفقیت بسته شد!',
				});
				this.getTicketList();
			}
		},
		newTicket() {
			this.$router.push({ name: 'newTicket' });
		},
		ticketDetailPage(id) {
			this.$router.push({ name: 'ticketDetail', params: { id: id } });
		},
	},
};
</script>
<style lang="scss" scoped>
.containers {
	padding: 24px;
	.warning {
		display: flex;
		flex-direction: column;
		border: 1px solid #ffecb4;
		background: #fff3cd;
		padding: 16px;
		margin-bottom: 32px;
		border-radius: 8px;

		ul {
			margin-bottom: 0 !important;
			padding: 10px 35px;
		}
		li {
			list-style: none;
		}
		.text {
			color: #664d03;
			font-size: 16px;
			margin-right: 15px;
		}
	}
	// .table {
	// 	border: 1px solid #c4c4c4;
	// }
	.new-ticket {
		background: #285595;
		color: #fff;
		border-radius: 8px;
		padding: 4px 10px;
		border: none;
		margin-bottom: 24px;
		.icon {
			width: 14px;
		}
	}
	.inputs {
		width: 100%;
		height: 38px;
		padding: 0 9px;
		font-family: 'IRANYekanfa' !important;
		border: none;
		border-radius: 8px;
		text-align: center;
	}
	.table-box {
		background: #fff;
		border-radius: 8px;
		padding: 24px;
	}
	.close-ticket {
		border: 1px solid #16c98d;
		color: #16c98d;
		background: #fff;
		padding: 6px;
		border-radius: 8px;
		font-size: 14px;
	}
	.ticket-detail {
		cursor: pointer;
	}

	.persian-number {
		font-family: 'IRANYekanfa' !important;
	}
}
</style>
<style>
.vpd-icon-btn {
	display: none !important;
}
.vpd-input-group input:disabled {
	background: #fff;
	text-align: center;
	min-width: 130px;
	border: none;
	font-family: 'IRANYekanfa' !important;
	font-size: 16px;
}
.VuePagination__count {
	display: none;
}
.page-item.active .page-link {
	background-color: #2d8b8b;
	border-radius: 8px;
}
.page-link {
	border: none;
	color: black;
	font-family: 'IRANYekanfa' !important;
}
</style>
